import React from 'react'
import { ReactComponent as BlueDiceSVG } from '../../../../../../lib/assets/blueDice.svg'
import { DiceWrapper } from '../../../AutoConfigStyles'

export default function DoubleRedDice() {
  return (
    <DiceWrapper>
      <BlueDiceSVG />
      <BlueDiceSVG />
    </DiceWrapper>
  )
}
